import { IS_LIVE } from "./Utility"

export const TABLE_ROW_PER_PAGE = 10
export const TABLE_PAGINATION_DROPDOWN = [10, 20, 30, 40, 50]
export const SOMETHING_ERR = "Something wen't wrong"
export const SERVER_ERR = "Server Error - Try Again"
export const ADMIN_LOGIN = "/admin/login"

export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const strongPasswordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&!@#$%^&*()_+[\]{}|;:,.<>/?])[A-Za-z\d@$!%*?&!@#$%^&*()_+[\]{}|;:,.<>/?]{8,}$/;

